/**
 * Pagination
 *
 * @module
 */

import { $$ } from '../../utilities/QuerySelectors.js';

export class Pagination {
    /**
     * Pagination container and buttons updates.
     *
     * @param {HTMLElement} container
     */
    constructor(container) {
        this.container = container;
    }

    /**
     * Initialize the enhancements for the pagination component.
     *
     * 1. Add classes to the edge buttons.
     * 2. Mark as ready to show.
     *
     * @return {void}
     */
    init() {
        setTimeout(() => this.container.classList.add('fouc-ready'), 64);
    }
}

/**
 * Initialize JS pagination component for each .pagination element in the document.
 *
 * @return {void}
 */
export function init() {
    $$('.pagination').forEach((el) => new Pagination(el).init());
}
